import React from "react";

// Brand lockup — pod icon (from the uploaded logo file) + a big serif
// "The Cardamom Trading Co." wordmark set beside it.
// Variants:
//   "dark"  — cream / scrolled surfaces  (green pod + gold wordmark)
//   "light" — dark surfaces              (cream pod + gold wordmark)
export const Logo = ({
  variant = "dark",
  compact = false,
  className = "",
  ...rest
}) => {
  const podSrc =
    variant === "light"
      ? "/logo-light-pod.png"
      : "/logo-transparent-pod.png";
  const gold = variant === "light" ? "#E8C866" : "#B08A1B";
  const green = variant === "light" ? "#FAF7F0" : "#1F5E3A";

  const podH = compact ? "h-14 md:h-16" : "h-20 md:h-24";
  const line1 = compact
    ? "text-[1.55rem] md:text-[1.85rem]"
    : "text-[2rem] md:text-[2.5rem]";
  const line2 = compact
    ? "text-[0.7rem] md:text-[0.78rem]"
    : "text-[0.82rem] md:text-[0.95rem]";

  return (
    <div
      className={`inline-flex items-center gap-3 md:gap-4 ${className}`}
      aria-label="The Cardamom Trading Co."
      {...rest}
    >
      {/* Pod icon — cropped from the uploaded brand logo */}
      <img
        src={podSrc}
        alt=""
        aria-hidden="true"
        className={`${podH} w-auto object-contain shrink-0`}
        loading="eager"
        decoding="async"
      />

      {/* Big serif wordmark */}
      <div className="flex flex-col leading-none">
        <span
          className={`font-serif ${line1}`}
          style={{
            color: gold,
            fontWeight: 500,
            lineHeight: 0.95,
            letterSpacing: "-0.005em",
          }}
        >
          The Cardamom
        </span>
        <span
          className={`font-serif ${line2}`}
          style={{
            color: green,
            fontWeight: 500,
            lineHeight: 1.1,
            marginTop: 6,
            letterSpacing: "0.28em",
            textTransform: "uppercase",
          }}
        >
          Trading&nbsp;Co
        </span>
      </div>
    </div>
  );
};

export default Logo;
